var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M20.586 2.228c.47.493.863.91 1.194 1.261 1.725 1.828 1.762 1.867 2.077 1.602a.406.406 0 0 0 .047-.573C21.537 1.348 20.702.076 19.997.144c-.486.047-.91.728-1.73 1.863-1.953 2.713-2.023 2.869-1.71 3.128.387.313.829-.218 2.367-2.065.23-.277.486-.583.769-.92-.127 4.263-.04 8.53.26 12.785a.406.406 0 1 0 .812 0 74.667 74.667 0 0 0-.179-12.707Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M2.831 5.632a8.568 8.568 0 0 0-.168-4.228.407.407 0 0 0-.81.051 9.915 9.915 0 0 0 .204 4.198.388.388 0 0 0 .774-.021Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M2.207 12.747c-.28.968-.24 2 .114 2.944a.407.407 0 0 0 .813-.03c.658-3.45-.978-3.781-.927-2.914Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M8.745 6.261a.407.407 0 0 0-.81.039c-.65 5.409 2.17 6.173.81-.039Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M8.621 17.488a14.76 14.76 0 0 0 .205 6.029.407.407 0 0 0 .807-.073c.16-1.988.08-3.987-.24-5.956a.386.386 0 1 0-.772 0Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M15.012 15.7a15.644 15.644 0 0 0 .259 5.779.406.406 0 0 0 .81-.052c.2-1.922.1-3.863-.295-5.754a.388.388 0 0 0-.774.026Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#82e1f2",
    fillRule: "evenodd",
    d: "M3.064 5.63C2.927 5.131.92 5.162.304 6.861a12.543 12.543 0 0 0-.29 3.34c.07 1.854.5 3.294 2.657 3.188 2.297-.112 2.126-2.054 1.988-4.11a11.489 11.489 0 0 0-.437-2.975c-.22-.52-.798-1.082-1.158-.676Zm-.09.364c-.275.293-1.365-.049-1.694 1.176a10.617 10.617 0 0 0-.049 2.975c.047.834.047 1.74.823 1.927 1.911.21 1.526-.723 1.448-3.884-.023-.433.083-1.696-.324-1.932a.401.401 0 0 1-.204-.262Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#82e1f2",
    fillRule: "evenodd",
    d: "M8.295 10.062c-.41-.298-1.207.425-1.481.891a9.027 9.027 0 0 0-.435 4.236c.233 1.984 1.253 3.227 3.223 2.797 2.142-.485 1.782-3.043 1.508-5.026-.26-1.771-.637-3.198-2.473-3.092a.404.404 0 0 0-.342.194Zm.093.518c-.215.316-1.515.117-.816 4.43.195 1.194.575 2 1.756 1.733 1.054-.233.777-2.134.653-3.672-.22-3.107-1.124-2.102-1.593-2.478v-.013Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#82e1f2",
    fillRule: "evenodd",
    d: "M15.253 9.348c-.322-.391-1.378.09-1.878.673a5.144 5.144 0 0 0-.189 5.295 2.409 2.409 0 0 0 4-.205c.573-.96.542-3.277-.258-4.857-.316-.624-1.28-1.266-1.675-.906Zm-.05.538a2.072 2.072 0 0 0-1.085.707 4.874 4.874 0 0 0-.114 3.687c.44.899 1.769.938 2.043.332.565-1.246.442-2.914.024-3.967-.257-.645-.67-.48-.868-.748v-.01Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrading);
export default __webpack_public_path__ + "static/media/trading.e7158c2d59a05be6741d219cea9ae93b.svg";
export { ForwardRef as ReactComponent };